import type { ReactNode } from "react";
import { Dices } from "lucide-react";

/** Section container with a title and an optional dice-roll button in the header. */
export function SectionCard({
  title,
  onRoll,
  rollDisabled,
  children,
}: {
  title: string;
  onRoll?: () => void;
  rollDisabled?: boolean;
  children: ReactNode;
}) {
  return (
    <section className="border-border bg-card mt-4 rounded-lg border p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-foreground text-sm font-semibold">{title}</h2>
        {onRoll && (
          <button
            type="button"
            onClick={onRoll}
            disabled={rollDisabled}
            title={`Randomize ${title.toLowerCase()}`}
            className="border-border text-muted-foreground hover:border-muted-foreground/40 hover:text-foreground rounded-md border p-1.5 transition disabled:cursor-not-allowed disabled:opacity-40"
          >
            <Dices className="h-4 w-4" />
          </button>
        )}
      </div>
      {children}
    </section>
  );
}

export function FormField({
  label,
  hint,
  className,
  children,
}: {
  label: string;
  hint?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label className={`block ${className ?? ""}`}>
      <span className="text-muted-foreground mb-1 block text-xs font-medium">
        {label}
      </span>
      {children}
      {hint && (
        <span className="text-subtle-foreground mt-1 block text-xs">
          {hint}
        </span>
      )}
    </label>
  );
}
